import { AxiosResponse } from 'axios';
import { jobBoardAPI } from './base';

const locationEndpoint = {
  getAll: '/location',
  create: '/location',
  update: '/location/:{id}',
  search: '/location/search'
};

export interface Location {
  _id: string;
  location: string;
  createdAt: string;
  updatedAt: string;
}

export interface LocationDTO {
  name: string;
  location: string;
  country: string;
}

export const GET_LOCATION_QUERY = async (): Promise<
  AxiosResponse<Location[]>
> => (await jobBoardAPI.get(locationEndpoint.getAll)).data;

export const CREATE_LOCATION = async (
  data: LocationDTO
): Promise<AxiosResponse<Location>> =>
  jobBoardAPI.post(locationEndpoint.create, data);

export const PATCH_LOCATION = async ({
  locationId,
  data
}: {
  locationId: string;
  data: LocationDTO;
}): Promise<AxiosResponse<Location>> =>
  jobBoardAPI.patch(locationEndpoint.update.replace(':{id}', locationId), data);

export const DELETE_LOCATION = async (
  locationId: string
): Promise<AxiosResponse<void>> => {
  const endpoint = `/location/${locationId}`;
  return jobBoardAPI.delete(endpoint);
};

export const SEARCH_LOCATIONS = async (
  query: string
): Promise<AxiosResponse<Location[]>> => {
  const term = encodeURIComponent(query.trim());
  const response = await jobBoardAPI.get(
    `${locationEndpoint.search}?q=${term}`
  );
  return response.data;
};
